<template>
	<div>
		<Person
			:v="v"
			:is-alternative-service-edit="isAlternativeServiceEdit"
			:is-manual="false"
			translationKey="noticeRecovery.applicant.person"
		>
			<slot></slot>
		</Person>
		<MrpaTrustee
			:v="v.trustee"
			label="Сведения о представителе физического лица"
		/>
	</div>
</template>

<script>
import MrpaTrustee, {
	mrpaTrusteeModel,
	getMrpaTrusteeValidation,
} from '@/components/services/elements/MrpaTrustee';
import Person, {personModel, personValidation} from '../Person';
import cloneDeep from 'clone-deep';

export const machinePersonModel = {
	...personModel,
	trustee: cloneDeep(mrpaTrusteeModel),
};

export const getMachinePersonValidation = (person) => ({
	...personValidation,
	trustee: getMrpaTrusteeValidation(person.trustee),
});

export default {
	name: 'MachinePerson',
	props: {
		v: {
			type: Object,
			required: true,
		},
		isAlternativeServiceEdit: {
			type: Boolean,
			required: true,
		},
	},
	components: {
		Person,
		MrpaTrustee,
	},
};
</script>
